export const patchRowByUserId = (rows, userEmailId, rowPatch) => {
  let rowMatched = false;

  const updatedRows = rows.map((row) => {
    if (row?.user_email_id !== userEmailId) {
      return row;
    }

    rowMatched = true;
    return {
      ...row,
      ...rowPatch,
    };
  });

  return rowMatched ? updatedRows : rows;
};
